import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import {
  IconStats,
  IconEdit,
  IconClose,
  IconFilter
} from '@contrast-security-inc/design-system-foundations'
import { Link } from '@contrast-security-inc/design-system-typography'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { SessionMetadataModal } from './session-metadata-modal'
import { useSessionMetadataAction } from './use-session-metadata-action'

const inlineIconCss = css`
  display: flex;
  align-items: center;
`
export const SessionMetadataActionBar = ({
  applicationUuid,
  organizationUuid,
  appName,
  filterToggle,
  filtersActive,
  filterFields,
  totalAppCustomAgentSession,
  onSessionChange
}) => {
  const intl = useIntl()
  const {
    isActive,
    isModalOpen,
    setIsModalOpen,
    onClear,
    onSubmit,
    onCancel,
    activeSession,
    isUsingMostRecentSession,
    isRemovableSession,
    hasCustomSession
  } = useSessionMetadataAction({
    applicationUuid,
    organizationUuid,
    onSessionChange,
    filterToggle,
    filtersActive,
    totalAppCustomAgentSession
  })

  return (
    <>
      <Stack flex="1" justifyContent="space-between">
        <Stack spacing="4px" alignItems="center">
          {isActive ? (
            <>
              <Link
                font="body"
                onClick={() => setIsModalOpen(true)}
                className={inlineIconCss}
              >
                {intl.formatMessage({ id: 'action_editFilter' })}
                <IconEdit size="sm" color="turquoise70" />
              </Link>
              <Link font="body" onClick={onClear} className={inlineIconCss}>
                {intl.formatMessage({ id: 'action_clearFilter' })}
                <IconClose size="sm" color="turquoise70" />
              </Link>
            </>
          ) : (
            <Link
              font="body"
              onClick={() => setIsModalOpen(true)}
              className={inlineIconCss}
            >
              {intl.formatMessage({ id: 'action_applyFilter' })}
              <IconFilter size="sm" color="turquoise70" />
            </Link>
          )}
        </Stack>
        {isActive && (
          <Stack spacing="4px" alignItems="center">
            <IconStats size="sm" color="turquoise70" />
            <Link font="metadata" onClick={onClear}>
              {intl.formatMessage({ id: 'detail_sessionMetadataClearHint' })}
            </Link>
          </Stack>
        )}
      </Stack>
      {isModalOpen && (
        <SessionMetadataModal
          isOpen={isModalOpen}
          onSubmit={onSubmit}
          onCancel={onCancel}
          onClear={onClear}
          activeSession={activeSession}
          appName={appName}
          filterFields={filterFields}
          applicationUuid={applicationUuid}
          organizationUuid={organizationUuid}
          isUsingMostRecentSession={isUsingMostRecentSession}
          isRemovableSession={isRemovableSession}
          hasCustomSession={hasCustomSession}
        />
      )}
    </>
  )
}
